let LayoutsList = {};
LayoutsList['Wireframe1'] = require('./wireframes/Wireframe1').default
LayoutsList['Wireframe2'] = require('./wireframes/Wireframe2').default
LayoutsList['Wireframe3'] = require('./wireframes/Wireframe3').default
LayoutsList['Wireframe4'] = require('./wireframes/Wireframe4').default
LayoutsList['Wireframe5'] = require('./wireframes/Wireframe5').default
LayoutsList['Wireframe6'] = require('./wireframes/Wireframe6').default


export default LayoutsList